import { render, staticRenderFns } from "./digit-b1.vue?vue&type=template&id=f5d87262&"
import script from "./digit-b1.vue?vue&type=script&lang=js&"
export * from "./digit-b1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports